import { render, staticRenderFns } from "./JsNavigationChildrenAbout.vue?vue&type=template&id=27eacc0a"
import script from "./JsNavigationChildrenAbout.vue?vue&type=script&lang=js"
export * from "./JsNavigationChildrenAbout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports